export type CubeBinaryFilter = {
  member: string;
  operator: string;
  values?: unknown[];
};

export type CubeFilter = CubeBinaryFilter | { or: CubeBinaryFilter[] };

export type CubeTimeDimension = {
  dimension: string;
  granularity?: "month" | "day" | "year" | "week";
  dateRange?: string | [string, string];
};

export type CubeOrderTuple = [string, "asc" | "desc"];

export type CubeLoadQuery = {
  measures?: string[];
  dimensions?: string[];
  timeDimensions?: CubeTimeDimension[];
  filters?: CubeFilter[];
  order?: CubeOrderTuple[] | Record<string, "asc" | "desc">;
  limit?: number;
};

const isRecord = (v: unknown): v is Record<string, unknown> => typeof v === "object" && v !== null;

export const readCubeDataRows = (raw: unknown): unknown[] | undefined => {
  if (!isRecord(raw)) return undefined;
  if (!("data" in raw)) return undefined;
  const { data } = raw;
  if (!Array.isArray(data)) return undefined;
  return data;
};

export const readCubeErrorMessage = (raw: unknown): string | undefined => {
  if (!isRecord(raw)) return undefined;
  if (typeof raw["error"] === "string") return raw["error"];
  const err = raw["error"];
  if (isRecord(err) && typeof err["message"] === "string") return err["message"];
  return undefined;
};
